import axios from 'axios';
import { toast } from 'sonner';

export function useSelectionLogic({ API, getAuthHeader, fetchData, filteredDocuments, setBulkProcessing, selectedIds, setSelectedIds, documentsEnAttente, calculateMontantTTC }) {

  const toggleSelection = (id) => {
    setSelectedIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const selectAllFiltered = () => {
    const ids = filteredDocuments.map(d => d.id);
    setSelectedIds(new Set(ids));
  };

  const deselectAll = () => {
    setSelectedIds(new Set());
  };

  const isAllFilteredSelected = filteredDocuments.length > 0 && 
    filteredDocuments.every(d => selectedIds.has(d.id));

  const handleBulkValidate = async () => {
    if (selectedIds.size === 0) {
      toast.error('Veuillez sélectionner au moins un document');
      return;
    }

    if (!window.confirm(`Confirmer la validation de ${selectedIds.size} paiement(s) ?`)) return;

    setBulkProcessing(true);
    let successCount = 0;
    let errorCount = 0;

    for (const id of selectedIds) {
      try {
        const doc = documentsEnAttente.find(d => d.id === id);
        if (!doc) continue;
        
        const payload = {
          date_virement: new Date().toISOString().split('T')[0],
          montant_ttc: calculateMontantTTC(doc),
          reference_virement: `BULK-${new Date().toISOString().slice(0,10)}-${id.slice(-6)}`,
          reference_paiement: `BULK-${new Date().toISOString().slice(0,10)}`,
          mode_paiement: 'virement',
          observations: 'Validation en masse'
        };
        
        await axios.post(
          `${API}/souscriptions/admin/${id}/validate-payment`,
          payload,
          { headers: getAuthHeader() }
        );
        successCount++;
      } catch {
        errorCount++;
      }
    }

    setBulkProcessing(false);
    
    if (successCount > 0) {
      toast.success(`${successCount} paiement(s) validé(s) avec succès !`);
    }
    if (errorCount > 0) {
      toast.error(`${errorCount} erreur(s) lors de la validation`);
    }
    
    setSelectedIds(new Set());
    fetchData(true);
  };

  const handleBulkDelete = async () => {
    if (selectedIds.size === 0) {
      toast.error('Veuillez sélectionner au moins un document');
      return;
    }

    if (!window.confirm(`Etes-vous sur de vouloir supprimer ${selectedIds.size} document(s) ? Cette action est irreversible.`)) return;

    setBulkProcessing(true);
    let successCount = 0;
    let errorCount = 0;

    for (const id of selectedIds) {
      try {
        await axios.delete(`${API}/souscriptions/admin/${id}`, {
          headers: getAuthHeader()
        });
        successCount++;
      } catch {
        errorCount++;
      }
    }

    setBulkProcessing(false);
    
    if (successCount > 0) {
      toast.success(`${successCount} document(s) supprime(s)`);
    }
    if (errorCount > 0) {
      toast.error(`${errorCount} erreur(s) lors de la suppression`);
    }
    
    setSelectedIds(new Set());
    fetchData(true);
  };

  return { toggleSelection, selectAllFiltered, deselectAll, isAllFilteredSelected, handleBulkValidate, handleBulkDelete };
}
